import { useState, useEffect } from "react";
import "./Marquee.css";

export default function Marquee() {
  const [banners, setBanners] = useState([]);
  const [newBannerText, setNewBannerText] = useState("");

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const response = await fetch("https://admin.riymay.com/api/v1/admin/marquee-banner", {
        method: "GET",
        headers: {
            "Content-Type": "application/json", 
            Authorization: `Bearer ${localStorage.getItem("admintoken")}`,
         },
        }
      );
      const data = await response.json();
      setBanners(data.marqueeBanner);
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  const createBanner = async () => {
    try {
      const response = await fetch("https://admin.riymay.com/api/v1/admin/marquee-banner", {
        method: "POST",
        headers: { 
            "Content-Type": "application/json" ,
            Authorization: `Bearer ${localStorage.getItem("admintoken")}`,

        },
        body: JSON.stringify({ marqueeBannerText: newBannerText }),
      });
      if (response.ok) {
        setNewBannerText("");
        fetchBanners();
      }
    } catch (error) {
      console.error("Error creating banner:", error);
    }
  };

  const deleteBanner = async (id) => {
    try {
      const response = await fetch(`https://admin.riymay.com/api/v1/admin/marquee-banner/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("admintoken")}`,
        },
      });
      if (response.ok) {
        fetchBanners();
      }
    } catch (error) {
      console.error("Error deleting banner:", error);
    }
  };

  return (
    <div className="table-container">

    <div className="search-bar-container">
    <h1 >Marquee Banners</h1>

<input
          type="text"
          className="search-bar "
          placeholder="Enter marquee text"
          value={newBannerText}
          onChange={(e) => setNewBannerText(e.target.value)}
        />
      <button onClick={createBanner} className="pincode-submit-btn">
          Create Banner
        </button>
    </div>














      <table className="marquee-table">
        <thead>
          <tr className="marquee-table-header">
            <th className="marquee-table-cell">Text</th>
            <th className="marquee-table-cell">Actions</th>
          </tr>
        </thead>
        <tbody>
          {banners.map((banner) => (
            <tr key={banner._id} className="marquee-table-row">
              <td className="marquee-table-cell">{banner.marqueeBannerText}</td>
              <td className="marquee-table-cell">
                <button onClick={() => deleteBanner(banner._id)} className="marquee-delete-button">
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
